<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Lote</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-md-12 col-md-offset-2">
          <div id="wizardCard" class="card card-wizard">
            <form-wizard
              :start-index="currentStage"
              color="#66615B"
              error-color="#EB5E28"
              shape="tab"
              subtitle=""
              title=""
              @on-change="onChange"
              @on-complete="wizardComplete"
            >
              <template slot="title">
                <advance :field="field.value" :plot="plot.value" :producer="producer.value" />
              </template>

              <tab-content :before-change="validateProducer" icon="fas fa-industry" title="Productor">
                <producer-select
                  v-if="!producer.new"
                  ref="producerSelect"
                  :selected="producer.selected"
                  @newProducer="newProducer(true)"
                >
                </producer-select>

                <producer-form v-if="producer.new" ref="producerForm" @selectProducer="newProducer(false)">
                </producer-form>
              </tab-content>

              <tab-content :before-change="validateField" icon="fas fa-map-marked" title="Campo">
                <field-select
                  v-if="!field.new"
                  ref="fieldSelect"
                  :producer="producer.value"
                  :selected="field.selected"
                  @newField="newField(true)"
                  @updatePlots="setPlots"
                >
                </field-select>

                <field-plots-map
                  v-if="isDataLoaded && $refs.fieldSelect.getSelected() && plots.length > 0"
                  map-id="field-plots-map"
                  map-type="satellite"
                  :zoom="5"
                  :plots="plots"
                />

                <span v-else>Este campo no posee lotes</span>

                <field-form v-if="field.new" ref="fieldForm" @selectField="newField(false)"> </field-form>
              </tab-content>

              <tab-content :before-change="validatePlot" icon="fas fa-seedling" title="Lote">
                <plot-form ref="plotForm"></plot-form>
              </tab-content>

              <tab-content icon="fas fa-check" title="Resumen">
                <resume :field="field.value" :plot="plot.value" :producer="producer.value" />
              </tab-content>

              <template slot="prev" scope="props">
                <button v-show="!props.isLastStep" slot="prev" class="btn btn-default btn-fill btn-wd btn-back">
                  Anterior
                </button>
              </template>

              <button slot="next" class="btn btn-success btn-fill btn-wd btn-next">Siguiente</button>
              <template slot="finish">
                <button class="btn btn-success btn-fill btn-wd" @click="gotoPlot">Ir al lote</button>
                <button class="btn btn-default btn-fill btn-wd" @click="gotoList">Volver al listado</button>
              </template>
            </form-wizard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { FormWizard, TabContent } from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import ProducerForm from './Forms/ProducerForm';
import ProducerSelect from './Forms/ProducerSelect';
import FieldForm from './Forms/FieldForm';
import FieldSelect from './Forms/FieldSelect';
import PlotForm from './Forms/PlotForm';
import Advance from './Widgets/Advance';
import Resume from './Widgets/Resume';
import FieldPlotsMap from './Map/FieldPlotsMap.vue';

export default {
  components: {
    RouteBreadCrumb,
    FormWizard,
    TabContent,
    ProducerForm,
    ProducerSelect,
    FieldForm,
    FieldSelect,
    PlotForm,
    Advance,
    Resume,
    FieldPlotsMap,
  },

  data() {
    return {
      validated: false,
      wizardModel: {},
      producer: {
        new: false,
        value: null,
        selected: null,
      },

      field: {
        new: false,
        value: null,
        selected: null,
      },

      plots: [],
      plot: {
        value: null,
      },

      isDataLoaded: false,
    };
  },

  computed: {
    currentStage() {
      if (this.$route.query.hasOwnProperty('field')) {
        return 2;
      }
      if (this.$route.query.hasOwnProperty('producer')) {
        return 1;
      }
      return 0;
    },
  },

  created() {
    if (this.$route.query.hasOwnProperty('producer')) {
      this.producer.selected = +this.$route.query.producer;
      this.getProducer().then(() => {
        if (this.$route.query.hasOwnProperty('field')) {
          this.field.selected = +this.$route.query.field;
          this.getField();
        }
      });
    }
  },

  methods: {
    setPlots(plots) {
      this.plots = plots;
      this.isDataLoaded = true;
    },

    getProducer() {
      const vm = this;
      return new Promise((resolve, reject) => {
        this.$services
          .resource('producers')
          .show(this.producer.selected)
          .then((res) => res.data.data)
          .then((producer) => {
            vm.producer.value = producer;
            resolve(true);
          })
          .catch((e) => {
            reject("couldn't get pre-selected producer");
          });
      });
    },

    getField() {
      const vm = this;
      return new Promise((resolve, reject) => {
        this.$services
          .resource('fields')
          .show(this.field.selected, { include: ['city.province', 'plots'] })
          .then((res) => res.data.data)
          .then((field) => {
            vm.field.value = field;
            resolve(true);
          })
          .catch((e) => {
            reject("couldn't get pre-selected field");
          });
      });
    },

    newProducer(value) {
      this.producer.new = value;
      this.producer.value = null;
    },

    newField(value) {
      this.field.new = value;
      this.field.value = null;
    },

    onChange(prev, next) {
      if (next === 0 && this.producer.new && this.producer.value) {
        this.producer.selected = this.producer.value.id;
        this.producer.new = false;
      }
      if (next === 1 && this.field.new && this.field.value) {
        this.field.selected = this.field.value.id;
        this.field.new = false;
      }
      if (prev > next && next === 1 && this.$route.query.hasOwnProperty('field')) {
        this.field.selected = null;
        this.field.value = null;
      }
    },

    validateProducer() {
      if (this.producer.new) {
        return this.$refs.producerForm.validate() && this.createProducer();
      }
      return this.$refs.producerSelect.validate() && this.selectProducer();
    },

    createProducer() {
      const vm = this;
      return new Promise((resolve, reject) => {
        this.$refs.producerForm
          .create()
          .then((res) => res.data.data)
          .then((producer) => {
            vm.producer.value = producer;
            this.$success('El productor fue creado con éxito!', 'Creado!');
            resolve(true);
          })
          .catch((e) => {
            this.$error('No se pudo crear el productor, revise los datos ingresados.');
            reject("couldn't create a new producer");
          });
      });
    },

    selectProducer() {
      return new Promise((resolve, reject) => {
        const selectedProducer = this.$refs.producerSelect.getSelected();
        if (selectedProducer) {
          this.producer.value = selectedProducer;
          resolve(true);
        }
        reject('error getting selected producer');
      });
    },

    validateField() {
      if (this.field.new) {
        return this.$refs.fieldForm.validate() && this.createField();
      }
      return this.$refs.fieldSelect.validate() && this.selectField();
    },

    createField() {
      const vm = this;
      return new Promise((resolve, reject) => {
        this.$refs.fieldForm
          .create(this.producer.value)
          .then((res) => res.data.data)
          .then((field) => {
            vm.field.value = field;
            this.$success('El campo fue creado con éxito!', 'Creado!');
            resolve(true);
          })
          .catch((e) => {
            this.$error('No se pudo crear el campo, revise los datos ingresados.');
            reject("couldn't create a new field");
          });
      });
    },

    selectField() {
      return new Promise((resolve, reject) => {
        const selectedField = this.$refs.fieldSelect.getSelected();
        if (selectedField) {
          this.field.value = selectedField;
          resolve(true);
        }
        reject('error getting selected field');
      });
    },

    validatePlot() {
      return this.$refs.plotForm.validate() && this.createPlot();
    },

    createPlot() {
      const vm = this;
      return new Promise((resolve, reject) => {
        this.$refs.plotForm
          .create(this.field.value)
          .then((res) => res.data.data)
          .then((plot) => {
            vm.plot.value = plot;
            this.$success('El lote fue creado con éxito!', 'Creado!');
            resolve(true);
          })
          .catch((e) => {
            this.$error('No se pudo crear el lote, revise los datos ingresados.');
            reject("couldn't create a new plot");
          });
      });
    },

    wizardComplete() {
      // we gather models from all steps into one model
      this.wizardModel = {
        ...this.producer.value,
        ...this.field.value,
        ...this.plot.value,
      };
    },

    gotoList() {
      this.$router.push({ name: 'PlotsList' });
    },

    gotoPlot() {
      this.$router.push({
        name: 'PlotShow',
        params: { id: this.plot.value.id },
      });
    },
  },
};
</script>
